export default {
  message: `Uporabljamo piškotke za zagotavljanje sodobne uporabniške izkušnje na našem spletnem mestu. V nadaljevanju si preberite naše <a href="https://www.btc.si/pogoji-uporabe/" target="_blank" class='underlined'>pogoje uporabe</a>.`,
  dismiss: `Sprejmem piškotke`,
};
